import React, { memo } from 'react'
import './styles.scss'

const TopRibbon = ({ items = [], backgroundColor }) => {
  if (!items.length) return null

  return (
    <nav
      className="top-ribbon navbar navbar-expand bg-dark hide-on-mobile py-0"
      role="navigation"
      style={{ backgroundColor: backgroundColor }}
      data-testid="Top-Ribbon-Navigation"
      aria-label="Top Ribbon Navigation">
      <div className="navbar-nav mx-auto d-flex flex-row gap-4 py-1">
        {items?.map((item, idx) => {
          return (
            <a
              key={idx}
              data-testid={item.label.replace(/\s+/g, '-')}
              className={'nav-link top-ribbon-link text-white fw-bold'}
              href={item.link}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={item.label}>
              {item.label}
            </a>
          )
        })}
      </div>
    </nav>
  )
}

export default memo(TopRibbon)
